{
  "welcome": {
    "title": "Welcome to My City",
    "tagline": "Report problems. Track progress. Improve your city.",
    "cta": {
      "google": "Continue with Google",
      "identityKind": "Sign in with",
      "phone": "Phone",
      "email": "Email",
      "continue": "Continue",
      "or": "or"
    }
  },
  "otp": {
    "title": "Enter the code",
    "subtitle": "We sent a 6-digit code to {{destination}}.",
    "input": "Verification code",
    "verify": "Verify",
    "resendIn": "Resend in {{seconds}}s",
    "resend": "Resend code",
    "changeIdentity": "Use a different phone or email"
  },
  "auth": {
    "errors": {
      "invalidIdentity": "Enter a phone (+14165551234) or email address",
      "sendFailed": "Couldn't send the code. Try again in a moment.",
      "invalidCode": "That code doesn't match. Try again.",
      "expired": "Code expired. Request a new one.",
      "lockout": "Too many wrong tries. Request a new code.",
      "accountConflict": "Another sign-in for this account is still finishing. Wait a moment, then try again.",
      "channelUnavailable": "That sign-in method isn't available right now. Please try another way to sign in.",
      "unexpected": "Something went wrong. Try again.",
      "invalidIdentityPhoneOnly": "Enter a phone number (+14165551234)",
      "accountDeactivated": "This account has been deactivated. Contact support if you think this is a mistake."
    },
    "signOut": "Sign out"
  },
  "home": {
    "header": "MY CITY",
    "anonymous": "citizen",
    "newsTitle": "City News",
    "eventsAnnouncementsTitle": "Events & Announcements",
    "projectsTitle": "City Projects",
    "pollsTitle": "Have your say",
    "viewAll": "View all",
    "weather": {
      "currentLocation": "Current location",
      "temperature": "{{value}}°C"
    },
    "banner": {
      "title": "Featured",
      "dot": "Go to banner {{index}}"
    },
    "highlights": {
      "title": "Highlights",
      "mine": {
        "problem": "My report",
        "request": "My request"
      },
      "dot": "Go to slide {{index}}"
    },
    "poll": {
      "title": "Have your say",
      "submit": "Submit",
      "voted": "Thanks for voting!",
      "changeVote": "Change my vote",
      "endsAt": "Voting closes {{when}}",
      "resultStat": "{{pct}}% ({{count}})",
      "voteFailed": "Couldn't submit your vote. Please try again.",
      "totalVotes": "{{count}} votes so far"
    },
    "newsDot": "Go to news item {{index}}",
    "eventsAnnouncementsDot": "Go to announcement or event {{index}}",
    "projectsDot": "Go to project {{index}}",
    "pollsDot": "Go to poll {{index}}",
    "sectionFailed": "This section didn't load."
  },
  "reportStatus": {
    "pending": "Submitted",
    "triaged": "Submitted",
    "assigned": "Assigned",
    "accepted": "Accepted",
    "in_progress": "In Progress",
    "resolved": "Resolved",
    "closed": "Closed",
    "reopened": "Reopened",
    "cancelled": "Rejected"
  },
  "reportKind": {
    "problem": "Problem",
    "request": "Request"
  },
  "report": {
    "title": {
      "problem": "New report",
      "request": "New request"
    },
    "city": "City",
    "kind": {
      "problem": "Report a problem",
      "problemHint": "Something is broken, unsafe or needs fixing.",
      "request": "Submit a request",
      "requestHint": "Ask the city for a service or an improvement."
    },
    "description": {
      "problem": "What would you like to report?",
      "request": "What are you asking the city for?"
    },
    "descriptionPlaceholder": {
      "problem": "Pothole on the south side of Main St, 50m east of Brant…",
      "request": "A new bin for the park entrance, or a tree that needs trimming…"
    },
    "location": "Location",
    "locationHint": "Drag the map to pinpoint the spot, or tap the locate button.",
    "photos": "Photos",
    "photo": {
      "camera": "Camera",
      "gallery": "Gallery",
      "remove": "Remove photo",
      "blockedByVoice": "Remove the voice message to add a photo.",
      "maxReached": "Maximum photos reached ({{max}}).",
      "someDropped": "Some photos weren't added — the limit is {{max}}.",
      "preparing": "Preparing photo…",
      "previewUnavailable": "Preview unavailable",
      "unreadable": "That photo couldn't be read. Take it again, or pick a JPEG or PNG.",
      "unreadable_other": "{{count}} of those photos couldn't be read. Take them again, or pick JPEG or PNG files."
    },
    "useMyLocation": "Use my current location",
    "submit": {
      "problem": "Submit report",
      "request": "Submit request"
    },
    "submitting": "Submitting…",
    "success": {
      "title": {
        "problem": "Report filed",
        "request": "Request sent"
      },
      "body": {
        "problem": "Your report has been logged. We've sent you a tracking code.",
        "request": "Your request has been logged. We've sent you a tracking code."
      },
      "trackingCode": "Tracking code",
      "viewReports": "View my reports",
      "fileAnother": "Send something else",
      "attachmentsFailed": "{{count}} attachment couldn't be uploaded — everything else was sent.",
      "attachmentsFailed_other": "{{count}} attachments couldn't be uploaded — everything else was sent.",
      "retryAttachments": "Try sending them again",
      "retrying": "Sending…",
      "attachmentsRecovered": "Everything has been uploaded.",
      "alreadyReported": "Someone reported this before you, as {{code}}. Yours is attached to the same job — you’ll get the same updates."
    },
    "errors": {
      "noCity": "Please select a city.",
      "cityLoadFailed": "Couldn't load the city list.",
      "noCityAvailable": "Reporting isn't available yet — no city is onboarded.",
      "tooShort": "Add a bit more detail (4 characters minimum).",
      "needDetailOrPhoto": "Add a photo or a short description (4 characters minimum).",
      "requestMediaLimit": "A request can include only one attachment. Keep one photo or one voice message and remove the rest.",
      "submitFailed": "Couldn't send it. Try again in a moment.",
      "geoDenied": "Permission to read your location was denied.",
      "noSeverity": "Please choose a severity level.",
      "locationFailed": "Couldn't get your location. Drag the pin to the right spot instead.",
      "locationUnconfirmed": "Tell us where this is before you continue: use the location button, drag the pin, or type an address.",
      "outsideServiceArea": "That spot is outside {{city}}’s service area. Move the pin to somewhere in the city, or switch city on the Review step.",
      "blockedTitle": "You can’t file new reports in this city",
      "blockedReason": "Reason given by the city: {{reason}}",
      "blockedUntil": "This lifts on {{date}}. It applies only to this city — the rest of your account is unaffected.",
      "blockedAppeal": "Think this is a mistake? Contact support"
    },
    "wizard": {
      "back": "Back",
      "next": "Next",
      "kindHint": "What would you like to send to the city?",
      "mediaHint": "Take a photo, add a short voice message, and describe what you're reporting.",
      "requestMediaHint": "Describe your request. You can attach at most one item — a single photo or a single voice message.",
      "locationHint": "We've pinned your location — drag the map to adjust it, or type an address below.",
      "severityHint": "How serious is it?",
      "reviewHint": "Check everything before you submit.",
      "steps": {
        "kind": "Type",
        "media": "Media",
        "location": "Location",
        "severity": "Severity",
        "review": "Review"
      },
      "locationUnconfirmed": "This pin is the city centre, not the spot you are reporting. Use the location button, drag the map, or type an address below."
    },
    "voice": {
      "title": "Voice message (optional)",
      "record": "Record voice",
      "stop": "Stop ({{seconds}}s)",
      "play": "Play",
      "pause": "Pause",
      "discard": "Discard recording",
      "hint": "Up to {{max}} seconds.",
      "unsupported": "Voice recording isn't supported on this browser.",
      "errors": {
        "micDenied": "Microphone access denied.",
        "playFailed": "Couldn't play the recording on this device."
      },
      "blockedByPhoto": "Remove the photo to record a voice message."
    },
    "charCount": "{{used}}/{{max}}",
    "severity": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "review": {
      "category": "Category (AI suggested)",
      "categoryAuto": "Automatic — let the city decide",
      "categoryLoading": "Analyzing your report…",
      "aiType": "AI classification",
      "aiTypeUse": "Use AI suggestion ({{type}})",
      "aiTypeSelect": "Select a type…",
      "aiTypeNoneOfThese": "None of these",
      "aiSeverity": "AI-estimated severity",
      "descriptionLoading": "AI is drafting a description from your photo…"
    },
    "addressSearch": {
      "label": "Or type an address",
      "placeholder": "e.g. 120 Main Street",
      "action": "Search this address",
      "searching": "Looking up that address…",
      "results": "Tap the right one — the pin moves there:",
      "tooShort": "Type at least 3 characters of the address.",
      "noResults": "No address matched that. Check the spelling, or drag the pin instead.",
      "degraded": "Address lookup is unavailable right now — this is not a spelling problem. Try again in a moment, or drag the pin instead.",
      "rateLimited": "Too many searches in a row. Wait about a minute, then try again.",
      "failed": "The address search didn't go through. Try again, or drag the pin instead.",
      "movedTo": "Pin moved to {{address}}"
    },
    "descriptionOptional": "Optional — your voice message says it"
  },
  "myReports": {
    "title": "Reports",
    "empty": "You haven't filed any reports yet.",
    "fileFirst": "File your first report",
    "filedAt": "Filed {{when}}",
    "viewToggle": "View as",
    "view": {
      "list": "List",
      "map": "Map"
    },
    "filterLabel": "Filter reports",
    "filterEmpty": "No reports match this filter.",
    "filters": {
      "all": "All",
      "pending": "Submitted",
      "active": "Active",
      "closed": "Closed & Rejected"
    }
  },
  "reportsMap": {
    "pinLabel": "{{code}} — {{status}}"
  },
  "validation": {
    "title": "Is the problem fixed?",
    "body": "The city says your report has been resolved. Let us know — if it isn't, we'll send the crew back.",
    "confirm": "Yes, it's fixed",
    "dispute": "No, still wrong",
    "disputeTitle": "What's still wrong?",
    "disputePlaceholder": "Pothole's been filled but the patch is already crumbling…",
    "disputeSubmit": "Reopen the report",
    "submitting": "Sending…",
    "failed": "Couldn't send your feedback. Try again.",
    "ratePrompt": "How was the service? Rate it to close the report.",
    "rateSubmit": "Submit rating",
    "starLabel_one": "{{count}} star",
    "starLabel_other": "{{count}} stars",
    "thanksTitle": "Thank you!",
    "thanksBody": "Your confirmation closed the report. Your Citizen Score just went up.",
    "reopenedTitle": "Report reopened",
    "reopenedBody": "We've sent the team back. You'll be notified when it's fixed.",
    "evidencePhotos": "Evidence photos (optional)",
    "evidenceVoice": "Voice message (optional)",
    "uploadingEvidence": "Uploading evidence ({{done}}/{{total}})…",
    "disputeTooShort": "Tell us a bit more (4 characters minimum).",
    "evidenceFailed": "{{count}} attachment failed to upload.",
    "evidenceFailed_other": "{{count}} attachments failed to upload."
  },
  "issueDetail": {
    "status": "Status",
    "kind": "Type",
    "description": "Description",
    "aiSummary": "AI reading",
    "filed": "Filed",
    "location": "Location",
    "openInMaps": "Open in Google Maps",
    "category": "Category",
    "address": "Address",
    "addressPending": "Reverse-geocoding in progress…",
    "photoUnavailable": "Photo unavailable",
    "photoDot": "Photo {{index}}",
    "categoryPending": "Awaiting triage",
    "timeline": "Progress",
    "transcript": "Voice transcript",
    "voiceNote": "Voice note",
    "voiceNoteFailed": "Couldn't load the voice message. Check your connection and try again.",
    "rejectedTitle": "Rejected",
    "rejectedNoReason": "The city closed this report without action.",
    "messages": {
      "title": "Messages",
      "empty": "No messages yet. Questions about this report? Write to the city here.",
      "placeholder": "Type a message…",
      "send": "Send",
      "staffBadge": "Staff",
      "sendFailed": "Couldn't send your message. Please try again."
    }
  },
  "profile": {
    "title": "Profile",
    "name": {
      "label": "Your name",
      "placeholder": "How should we call you?",
      "edit": "Edit your name",
      "failed": "Couldn't save your name.",
      "promptTitle": "What should we call you?",
      "promptBody": "You signed up with your phone number, so we don't have a name for you yet.",
      "promptCta": "Add your name"
    },
    "roles": "Roles",
    "language": "Language",
    "support": "Help & support",
    "avatar": {
      "change": "Change photo",
      "remove": "Remove photo",
      "failed": "Couldn't update your photo. Try again.",
      "tooLarge": "Photo is too large — please pick one under 5 MB.",
      "unreadable": "That image couldn't be read. Try another photo, or a JPEG or PNG."
    },
    "notifications": {
      "title": "Notifications",
      "statusUpdates": "Report status updates",
      "announcements": "City updates",
      "updateFailed": "Couldn't save your preference. Try again.",
      "enablePrompt": "Get push notifications for your reports",
      "enable": "Enable",
      "enableFailed": "Couldn't enable notifications",
      "blocked": "Notifications are blocked in your browser settings.",
      "unsupported": "This browser doesn't support notifications.",
      "iosInstallRequired": "Notifications on iPhone need My City added to your Home Screen.",
      "iosInstallAction": "Show me how",
      "iosOpenInSafari": "Open My City in Safari to add it to your Home Screen — notifications can't be turned on from inside this app's browser."
    },
    "role": {
      "citizen": "Citizen",
      "crew_member": "Team member",
      "group_manager": "Department manager",
      "supervisor": "Supervisor",
      "city_manager": "City manager",
      "system_admin": "System admin"
    },
    "stats": {
      "title": "My activity",
      "submitted": "Reports Submitted",
      "resolved": "Reports Resolved",
      "citizenScore": "Citizen Score",
      "reopened": "Reopened Cases"
    },
    "city": {
      "label": "City",
      "hint": "Your city is detected automatically — change it here if needed.",
      "unavailable": "Unavailable right now"
    },
    "identity": {
      "title": "Sign-in methods",
      "subtitle": "Add the one you didn’t sign up with — if you already have another account there, the two are merged and nothing is lost.",
      "phone": "Phone",
      "email": "Email",
      "add": "Add",
      "phonePlaceholder": "+1 416 555 1234",
      "emailPlaceholder": "name@example.com",
      "sendCode": "Send code",
      "codeSent": "Enter the 6-digit code sent to {{target}}.",
      "codePlaceholder": "······",
      "verify": "Verify",
      "addedNote": "Added — you can now sign in either way.",
      "mergedNote": "Verified — your other account was merged into this one. All its reports and messages are here now.",
      "errors": {
        "invalidPhone": "Enter the full number with country code (e.g. +1…).",
        "invalidEmail": "Enter a valid email address.",
        "emailUnavailable": "Email verification isn’t available yet — try again once email service is enabled.",
        "tooManySends": "Too many attempts — wait a minute and try again.",
        "alreadyYours": "This is already on your account.",
        "invalidCode": "Wrong or expired code.",
        "conflict": "This identifier can’t be added to this account.",
        "sendFailed": "Couldn’t send the code. Try again.",
        "verifyFailed": "Verification failed. Try again.",
        "slotOccupied": "Your account already has one — contact support to change it.",
        "needsOperator": "The other account has staff access in a different city. Ask an administrator to merge them."
      }
    }
  },
  "announcements": {
    "title": "City Updates",
    "kind": {
      "news": "News",
      "announcement": "Announcement",
      "event": "Event"
    },
    "empty": "Your city hasn't posted anything yet. Check back soon.",
    "learnMore": "Learn more",
    "imageDot": "Go to image {{index}}",
    "category": {
      "emergency": "Emergency",
      "road_work": "Road work",
      "event": "Event",
      "project_update": "Project update",
      "notice": "Notice",
      "general": "General"
    },
    "addToCalendar": "Add to calendar",
    "comments": {
      "title": "Comments",
      "placeholder": "Add a comment…",
      "send": "Post comment",
      "failed": "Couldn't post your comment. Try again.",
      "empty": "No comments yet. Be the first to say something.",
      "staffBadge": "Staff",
      "anonymous": "Anonymous",
      "delete": "Delete comment",
      "deleteConfirm": "Delete this comment? This can't be undone."
    }
  },
  "projectDetail": {
    "title": "City project",
    "completion": "Completion",
    "startDate": "Start",
    "endDate": "Expected end"
  },
  "common": {
    "loading": "Loading...",
    "error": "Something went wrong",
    "retry": "Retry",
    "cancel": "Cancel",
    "save": "Save",
    "back": "Back",
    "dismiss": "Dismiss",
    "charCount": "{{used}}/{{max}}",
    "loadMore": "Load more"
  },
  "locale": {
    "name": "Language",
    "en": "English",
    "fr": "Français",
    "qaRtl": "QA (RTL stub)"
  },
  "map": {
    "title": "City map",
    "layersLabel": "Map layers",
    "layers": {
      "issues": "Reports",
      "projects": "Projects",
      "eventsAnnouncements": "Events & announcements",
      "news": "City news"
    },
    "viewDetails": "View details",
    "cluster": "Cluster",
    "heat": "Heatmap",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "locate": "Find my location",
    "locateDenied": "Location access is blocked — allow it in your browser settings to use this.",
    "locateUnavailable": "Your location is unavailable right now. Try again later.",
    "projectCompletion": "{{pct}}% complete",
    "unavailable": "This browser can’t display the map. The address and coordinates are shown above."
  },
  "theme": {
    "label": "Theme",
    "light": "Light",
    "system": "System",
    "dark": "Dark"
  },
  "ios": {
    "installTitle": "Install My City",
    "installBody": "Tap the share button below, then \"Add to Home Screen\" to install. Lets the app receive notifications about your reports."
  },
  "nav": {
    "home": "Home",
    "map": "Map",
    "reports": "Reports",
    "profile": "Profile",
    "reportIssue": "New report or request"
  },
  "issueCategory": {
    "infrastructure": "Infrastructure",
    "green_space": "Green space",
    "sanitation": "Sanitation",
    "safety_traffic": "Safety & traffic",
    "equipment": "Equipment",
    "other": "Other"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "You're all caught up.",
    "markAllRead": "Mark all read",
    "updateFailed": "Couldn't mark as read. Check your connection and try again.",
    "events": {
      "work_order_assigned": {
        "problem": "Your report was assigned",
        "request": "Your request was assigned"
      },
      "work_order_in_progress": {
        "problem": "Work has started on your report",
        "request": "Work has started on your request"
      },
      "work_order_resolved": {
        "problem": "Your report has been resolved",
        "request": "Your request has been completed"
      },
      "work_order_closed": {
        "problem": "Your report was closed",
        "request": "Your request was closed"
      },
      "work_order_reopened": {
        "problem": "Your report was reopened",
        "request": "Your request was reopened"
      },
      "work_order_cancelled": {
        "problem": "Your report was rejected",
        "request": "Your request was rejected"
      },
      "issue_message": "New message on your report",
      "issue_message_coded": "New message on your report {{code}}",
      "support_reply": "Support replied to your ticket",
      "issue_created": {
        "problem": "New report filed",
        "request": "New request filed"
      },
      "validation_reopened": "Report reopened",
      "validation_closed": "Report confirmed fixed",
      "support_ticket_opened": "New support ticket",
      "support_ticket_reply": "A citizen replied on a support ticket"
    }
  },
  "projectStatus": {
    "planned": "Planned",
    "in_progress": "In progress",
    "completed": "Completed"
  },
  "support": {
    "title": "Support",
    "new": "New ticket",
    "newTitle": "New support ticket",
    "subject": "Subject",
    "message": "Message",
    "submit": "Submit",
    "empty": "You haven't contacted support yet.",
    "status": {
      "open": "Open",
      "answered": "Answered",
      "closed": "Closed"
    },
    "close": "Close ticket",
    "closeConfirm": "Close this ticket? You can still view it, but you won't be able to reply.",
    "closedNote": "This ticket is closed.",
    "messagePlaceholder": "Type a message…",
    "send": "Send",
    "staffBadge": "Staff",
    "errors": {
      "createFailed": "Couldn't create the ticket. Try again in a moment."
    },
    "sendFailed": "Couldn't send your message. Please try again.",
    "closeFailed": "Couldn't close the ticket. Please try again."
  },
  "announcementDetail": {
    "when": "When",
    "addToCalendar": "Add to calendar"
  },
  "dates": {
    "today": "Today",
    "yesterday": "Yesterday"
  },
  "reportDetail": {
    "alreadyReported": "Someone had already reported this as {{code}}. Your report is attached to the same job, so the status here is the real one."
  }
}
